<div *ngIf="!listNav; else list" class="navigation">
    <img src="assets/icone_varie/breadcrumbs.svg">
    <span class="roboTitle">{{title}}</span>
</div>
<ng-template #list>
    <div class="navigation">
        <img src="assets/icone_varie/breadcrumbs.svg">
        <ng-container *ngFor="let l of listNav">
            <span (click)="clickNav.emit(l.id)" class="roboMenu link">{{l.label}}</span>
            <span *ngIf="listNav!.indexOf(l) < listNav!.length -1" class="roboMenu">/</span>
        </ng-container>
    </div>
</ng-template>


<!-- <div *ngIf="!listNav; else list" class="navigation">
    <img src="assets/icone_varie/breadcrumbs.svg">
    <span class="roboTitle">{{navigator}} {{companyNameSelected}} {{childSelected}}</span>
</div> -->